import { ArrowRight, Award, Brain, Rocket, Shield, Target, TrendingUp } from 'lucide-react';
import React from 'react';
import Navigation from './ZeronineHeader';
import Footer from './ZeronineFooter';
import { Link } from 'react-router-dom';

const AboutPage = () => {

   return (
      <>
         <Navigation />
         {/* About Hero - Stunning */}
         <section className="relative min-h-[70vh] flex items-center justify-center overflow-hidden bg-gradient-to-br from-slate-950 via-blue-950 to-indigo-950 pt-20">
            <div className="absolute inset-0">
               <div className="absolute inset-0 bg-[radial-gradient(circle_at_50%_50%,rgba(59,130,246,0.3),transparent_50%)]"></div>
               <div className="absolute inset-0 bg-[linear-gradient(rgba(255,255,255,0.03)_1px,transparent_1px),linear-gradient(90deg,rgba(255,255,255,0.03)_1px,transparent_1px)] bg-[size:50px_50px]"></div>
            </div>

            <div className="relative z-10 max-w-7xl mx-auto px-4 text-center">
               <div className="inline-block px-4 py-2 bg-white/10 backdrop-blur-xl rounded-full mb-8 border border-white/20">
                  <span className="text-white font-bold">🚀 OUR STORY</span>
               </div>
               <h1 className="text-6xl md:text-8xl font-black text-white mb-6">About ZeroNine</h1>
               <p className="text-2xl text-gray-300 max-w-3xl mx-auto">
                  Empowering Indian businesses with AI-driven accounting solutions since 2020
               </p>
            </div>
         </section>

         {/* Mission & Vision - Premium Cards */}
         <section className="py-32 px-4 bg-white">
            <div className="max-w-7xl mx-auto">
               <div className="grid md:grid-cols-2 gap-12 items-stretch">

                  <div className="relative group h-full">
                     <div className="absolute inset-0 bg-gradient-to-br from-blue-600 to-indigo-600 rounded-3xl blur-xl opacity-20 group-hover:opacity-30 transition-opacity"></div>
                     <div className="relative bg-gradient-to-br from-blue-50 to-indigo-100 p-12 rounded-3xl border-2 border-blue-200 hover:border-blue-400 transition-all h-full">  {/* ✅ add h-full */}
                        <div className="absolute -top-8 -left-8 w-20 h-20 bg-gradient-to-r from-blue-600 to-indigo-600 rounded-2xl flex items-center justify-center shadow-2xl">
                           <Target className="w-10 h-10 text-white" />
                        </div>
                        <div className="mt-8">
                           <h3 className="text-4xl font-black text-gray-900 mb-6">Our Mission</h3>
                           <p className="text-gray-700 text-lg leading-relaxed">
                              To simplify accounting and financial management for every Indian business using artificial
                              intelligence. We believe that managing finances should be intelligent, accessible, and
                              automated for everyone.
                           </p>
                        </div>
                     </div>
                  </div>

                  <div className="relative group h-full">
                     <div className="absolute inset-0 bg-gradient-to-br from-purple-600 to-pink-600 rounded-3xl blur-xl opacity-20 group-hover:opacity-30 transition-opacity"></div>
                     <div className="relative bg-gradient-to-br from-purple-50 to-pink-100 p-12 rounded-3xl border-2 border-purple-200 hover:border-purple-400 transition-all h-full">  {/* ✅ add h-full */}
                        <div className="absolute -top-8 -left-8 w-20 h-20 bg-gradient-to-r from-purple-600 to-pink-600 rounded-2xl flex items-center justify-center shadow-2xl">
                           <Award className="w-10 h-10 text-white" />
                        </div>
                        <div className="mt-8">
                           <h3 className="text-4xl font-black text-gray-900 mb-6">Our Vision</h3>
                           <p className="text-gray-700 text-lg leading-relaxed">
                              To become India's most intelligent and user-friendly accounting platform, helping millions
                              of businesses grow and thrive by providing them with AI-powered financial tools.
                           </p>
                        </div>
                     </div>
                  </div>

               </div>
            </div>
         </section>

         {/* Our Story - Timeline Style */}
         <section className="py-32 px-4 bg-gradient-to-b from-gray-50 to-white">
            <div className="max-w-5xl mx-auto">
               <div className="text-center mb-16">
                  <div className="inline-block px-4 py-2 bg-blue-100 rounded-full mb-6">
                     <span className="text-blue-600 font-bold">📖 THE JOURNEY</span>
                  </div>
                  <h2 className="text-5xl md:text-6xl font-black text-gray-900 mb-6">Our Story</h2>
                  <p className="text-xl text-gray-600">How ZeroNine evolved with AI technology</p>
               </div>

               <div className="relative bg-white rounded-3xl shadow-2xl p-12 border-2 border-gray-200">
                  <div className="space-y-8">
                     <div className="flex gap-4">
                        <div className="flex-shrink-0 w-12 h-12 bg-blue-100 rounded-full flex items-center justify-center font-bold text-blue-600">
                           1
                        </div>
                        <div>
                           <h4 className="text-xl font-bold text-gray-900 mb-2">2020 - The AI Beginning</h4>
                           <p className="text-gray-700 leading-relaxed">
                              ZeroNine was born out of frustration with complex accounting software. Our founder, a
                              chartered accountant with AI expertise, decided to create an intelligent solution that
                              would work for Indian businesses using machine learning.
                           </p>
                        </div>
                     </div>

                     <div className="flex gap-4">
                        <div className="flex-shrink-0 w-12 h-12 bg-indigo-100 rounded-full flex items-center justify-center font-bold text-indigo-600">
                           2
                        </div>
                        <div>
                           <h4 className="text-xl font-bold text-gray-900 mb-2">2022 - AI Integration</h4>
                           <p className="text-gray-700 leading-relaxed">
                              We integrated advanced AI features including predictive analytics, automated document
                              processing, and intelligent workflow automation. Our focus was clear: make accounting
                              smart, GST compliance automated, and pricing affordable.
                           </p>
                        </div>
                     </div>

                     <div className="flex gap-4">
                        <div className="flex-shrink-0 w-12 h-12 bg-purple-100 rounded-full flex items-center justify-center font-bold text-purple-600">
                           3
                        </div>
                        <div>
                           <h4 className="text-xl font-bold text-gray-900 mb-2">2024 - AI Leadership</h4>
                           <p className="text-gray-700 leading-relaxed">
                              Today, ZeroNine serves over 50,000 businesses across India with cutting-edge AI
                              technology. We've processed more than ₹500 crores in transactions using our AI systems and
                              helped countless entrepreneurs focus on growth while AI handles the numbers.
                           </p>
                        </div>
                     </div>
                  </div>
               </div>
            </div>
         </section>

         {/* Values - Icon Grid */}
         <section className="py-32 px-4 bg-white">
            <div className="max-w-7xl mx-auto">
               <div className="text-center mb-20">
                  <div className="inline-block px-4 py-2 bg-purple-100 rounded-full mb-6">
                     <span className="text-purple-600 font-bold">💎 CORE VALUES</span>
                  </div>
                  <h2 className="text-5xl md:text-6xl font-black text-gray-900 mb-6">Our Core Values</h2>
                  <p className="text-xl text-gray-600">The principles that guide everything we do with AI</p>
               </div>

               <div className="grid md:grid-cols-3 gap-8">
                  {[
                     {
                        icon: Brain,
                        title: 'AI Innovation',
                        desc: 'We continuously evolve our AI algorithms to provide smarter, more intuitive accounting solutions.',
                        gradient: 'from-blue-600 to-indigo-600',
                     },
                     {
                        icon: Shield,
                        title: 'Trust & Security',
                        desc: 'We treat your financial data with the highest level of AI-powered security and blockchain protection.',
                        gradient: 'from-green-600 to-emerald-600',
                     },
                     {
                        icon: TrendingUp,
                        title: 'Continuous Learning',
                        desc: 'Our AI systems learn from user behavior to continuously improve and provide better recommendations.',
                        gradient: 'from-purple-600 to-pink-600',
                     },
                  ].map((value, idx) => (
                     <div key={idx} className="relative group">
                        <div
                           className={`absolute inset-0 bg-gradient-to-br ${value.gradient} rounded-3xl blur-xl opacity-20 group-hover:opacity-30 transition-opacity`}></div>
                        <div className="relative bg-gradient-to-br from-blue-50 to-indigo-50 rounded-3xl p-10 border-2 border-blue-100 hover:border-blue-300 hover:shadow-2xl transition-all text-center">
                           <div
                              className={`w-20 h-20 bg-gradient-to-r ${value.gradient} rounded-full flex items-center justify-center mx-auto mb-6 shadow-xl`}>
                              <value.icon className="w-10 h-10 text-white" />
                           </div>
                           <h3 className="text-2xl font-black text-gray-900 mb-4">{value.title}</h3>
                           <p className="text-gray-600 leading-relaxed">{value.desc}</p>
                        </div>
                     </div>
                  ))}
               </div>
            </div>
         </section>

         {/* Team - Modern Cards */}
         <section className="py-32 px-4 bg-gradient-to-b from-gray-50 to-white">
            <div className="max-w-7xl mx-auto">
               <div className="text-center mb-20">
                  <div className="inline-block px-4 py-2 bg-indigo-100 rounded-full mb-6">
                     <span className="text-indigo-600 font-bold">👥 MEET THE TEAM</span>
                  </div>
                  <h2 className="text-5xl md:text-6xl font-black text-gray-900 mb-6">Meet Our AI Experts</h2>
                  <p className="text-xl text-gray-600">The team behind ZeroNine's AI success</p>
               </div>

               <div className="grid md:grid-cols-3 gap-8">
                  {[
                     {
                        name: 'Kinjas Galiya',
                        role: 'Founder & CEO',
                        desc: 'Strategic leadership and business growth',
                        initials: 'KG',
                     },
                     {
                        name: 'Sujal Madhwani',
                        role: 'CTO',
                        desc: 'Technical leadership and architecture',
                        initials: 'SM',
                     },
                     {
                        name: 'Snehal Batra',
                        role: 'Project Manager',
                        desc: 'Coordinates projects and ensures timely delivery',
                        initials: 'SB',
                     },
                  ].map((member, idx) => (
                     <div key={idx} className="relative group">
                        <div className="absolute inset-0 bg-gradient-to-br from-blue-600 to-indigo-600 rounded-3xl blur-xl opacity-20 group-hover:opacity-30 transition-opacity"></div>
                        <div className="relative bg-white rounded-3xl p-10 border-2 border-gray-200 hover:border-blue-300 hover:shadow-2xl transition-all text-center h-[350px] flex flex-col">
                           <div className="relative mx-auto mb-6 w-32 h-32 flex-shrink-0">
                              <div className="absolute inset-0 bg-gradient-to-r from-blue-600 to-indigo-600 rounded-full blur opacity-50"></div>
                              <div className="relative w-32 h-32 bg-gradient-to-r from-blue-600 to-indigo-600 rounded-full flex items-center justify-center shadow-xl">
                                 <span className="text-4xl font-black text-white">{member.initials}</span>
                              </div>
                           </div>
                           <h3 className="text-2xl font-black text-gray-900 mb-2">{member.name}</h3>
                           <p className="text-blue-600 font-bold mb-4 text-lg">{member.role}</p>
                           <p className="text-gray-600 leading-relaxed mb-4">{member.desc}</p>
                        </div>
                     </div>
                  ))}
               </div>
            </div>
         </section>

         {/* CTA */}
         <section className="py-32 px-4 bg-gradient-to-r from-blue-600 via-indigo-600 to-purple-600 relative overflow-hidden">
            <div className="absolute inset-0 bg-[radial-gradient(circle_at_50%_50%,rgba(255,255,255,0.1),transparent_50%)]"></div>

            <div className="relative max-w-4xl mx-auto text-center text-white">
               <h2 className="text-5xl md:text-6xl font-black mb-8">Join the ZeroNine AI Revolution</h2>
               <p className="text-2xl mb-12 text-blue-100">Become part of India's smartest business community</p>
               <Link to={'/'}>
                  <button className="group bg-white text-blue-600 px-8 py-4 rounded-2xl font-bold text-lg hover:shadow-2xl hover:scale-105 transition-all duration-300 flex items-center gap-3 mx-auto">
                     <Rocket className="w-6 h-6 group-hover:rotate-12 transition-transform" />
                     Start Free Trial
                     <ArrowRight className="w-6 h-6 group-hover:translate-x-2 transition-transform" />
                  </button>
               </Link>
            </div>
         </section>

         <Footer />
      </>
   );
};

export default AboutPage;
